import React, { useState } from 'react'

import DBSData from 'Data/DBSData.js'
import GraphicSection from 'Components/GraphicSection/GraphicSection.js'
import InfoPopup from 'Components/InfoPopup/InfoPopup.js';

import mainBGDesk from 'Assets/HeroGraphic/hero_bg_desktop.png'
import mainBGMob from 'Assets/HeroGraphic/hero_bg_desktop.png'

import HeroGraphic from 'Components/HeroGraphic/HeroGraphic';
import GraphicCarousel from 'Components/GraphicCarousel/GraphicCarousel.js'

import "App.scss"

function App() {

  const [uiState, setUiState] = useState({
    infoPopupActive:false
  });

  // const heightDevice = useMediaQuery({ minHeight: 730 })
  const [selectedGraphicIndex, setSelectedGraphicIndex] = useState(-1);
  let alltheIcons = Object.keys(DBSData.ICONS).length;

  function onInfoPopupClosed(){
    setUiState({
      infoPopupActive:false
    })
    setSelectedGraphicIndex(-1);
  }

  function onGraphicSelected(key){
    setUiState({
      infoPopupActive:true
     
    })
    setSelectedGraphicIndex(getGraphicIndes(key) -1)
  }

  function showCurrentContent(key){
    let graphicIndex= getGraphicIndes(key) -1;

    if(graphicIndex === selectedGraphicIndex){
      return true;
    }else{
      return false;
    }
  }

  function getGraphicIndes(key){
    let keyindex = Object.keys(DBSData.ICONS).indexOf(key);
    return keyindex+1
  }


  function goToNext(){
    let nextGraphic = selectedGraphicIndex + 1
    setSelectedGraphicIndex(nextGraphic)

    if(nextGraphic >= alltheIcons){
      setSelectedGraphicIndex(0)
    }

 }

 function goToPrev(){
    let prevGraphic = selectedGraphicIndex - 1
    setSelectedGraphicIndex(prevGraphic)

    if(prevGraphic === (- 1)){
      setSelectedGraphicIndex(alltheIcons -1)
    }
 }

  return (
    <div className="App">
        <div className={`main_bg App__icons_container`}
          style={
              {
                backgroundImage: `url(${mainBGDesk})`
              }
          }>


            <HeroGraphic heroGraphicSmallTitle={DBSData.INTRO_PANEL.smallTitle} heroGraphicTitle={DBSData.INTRO_PANEL.title} heroGraphicIcon={DBSData.INTRO_PANEL.icon}/>
            <div className={`icons_container`}>
          
              <GraphicSection graphicKey={`onDemand`} graphicIndex={getGraphicIndes("onDemand")} graphicData={DBSData.ICONS.onDemand} showMe={showCurrentContent('onDemand')} onGraphicSelectedCallback={onGraphicSelected} />
        
              <GraphicSection graphicKey={`greenAndClean`} graphicIndex={getGraphicIndes("greenAndClean")} graphicData={DBSData.ICONS.greenAndClean} showMe={showCurrentContent('greenAndClean')} onGraphicSelectedCallback={onGraphicSelected} />
          
              <GraphicSection graphicKey={`highQualityTimeless`} graphicIndex={getGraphicIndes("highQualityTimeless")} graphicData={DBSData.ICONS.highQualityTimeless}  showMe={showCurrentContent('highQualityTimeless')} onGraphicSelectedCallback={onGraphicSelected} />
          
              <GraphicSection graphicKey={`fairEthical`} graphicIndex={getGraphicIndes("fairEthical")} graphicData={DBSData.ICONS.fairEthical} showMe={showCurrentContent('fairEthical')} onGraphicSelectedCallback={onGraphicSelected} />
          
              <GraphicSection graphicKey={`repairRedesign`} graphicIndex={getGraphicIndes("repairRedesign")} graphicData={DBSData.ICONS.repairRedesign}  showMe={showCurrentContent('repairRedesign')} onGraphicSelectedCallback={onGraphicSelected} />
        
              <GraphicSection graphicKey={`rentLease`} graphicIndex={getGraphicIndes("rentLease")} graphicData={DBSData.ICONS.rentLease} showMe={showCurrentContent('rentLease')} onGraphicSelectedCallback={onGraphicSelected} />
      
              <GraphicSection graphicKey={`secondHand`} graphicIndex={getGraphicIndes("secondHand")} graphicData={DBSData.ICONS.secondHand} showMe={showCurrentContent('secondHand')} onGraphicSelectedCallback={onGraphicSelected} />
            </div>
            <InfoPopup active={uiState.infoPopupActive} onCloseCallback={onInfoPopupClosed} infoPopupSelected={selectedGraphicIndex}  modalData={DBSData.ICONS} next={goToNext} prev={goToPrev}></InfoPopup>
          </div>

          <div className={`main_bg App__carousel_container`}
            style={
                {
                  backgroundImage: `url(${mainBGMob})`
                }
            }>
            <GraphicCarousel carouselData={DBSData.ICONS}/>
          </div>
    
    </div>
  );
}

export default App;
